export default "__VITE_PUBLIC_ASSET__960e794c__"